import React from 'react';
import { Card } from '../../../ui/molecules/Card';
import { Text } from '../../../ui/atoms/Text';
import { SectionHeader } from '../../../ui/molecules/SectionHeader';
import type { ExperienceItem } from '../resume.types';

type ExperienceSectionProps = {
  items: ExperienceItem[];
};

export function ExperienceSection({ items }: ExperienceSectionProps) {
  return (
    <section
      id="resume"
      className="px-4 py-16 dark:bg-stone-900"
      aria-labelledby="experience-heading"
    >
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          title="Experience"
          id="experience-heading"
          subtitle="13+ years building and shipping mobile products"
        />
        <ul className="space-y-6">
          {items.map((job, index) => (
            <li key={job.id}>
              <Card animationDelay={index * 80}>
                <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                  <div>
                    <Text as="h3" variant="h3">
                      {job.role}
                    </Text>
                    <Text variant="body" className="mt-0.5 font-medium text-emerald-700 dark:text-emerald-400">
                      {job.company}
                    </Text>
                  </div>
                  <span className="text-sm font-medium text-stone-500 dark:text-stone-400 sm:shrink-0">
                    {job.period}
                  </span>
                </div>
                <ul className="mt-4 space-y-2 pl-4">
                  {job.highlights.map((highlight, i) => (
                    <li
                      key={i}
                      className="text-stone-600 before:mr-2 before:content-['•'] before:text-emerald-500 dark:text-stone-400"
                    >
                      {highlight}
                    </li>
                  ))}
                </ul>
              </Card>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
